module.exports = __webpack_public_path__ + "img/ic-share.fd70ff6e.png";